module.exports = __webpack_public_path__ + "img/SketchPngb08f5bdac18c17794e9a51ffe0c768176d9767aa791d13b16c3baa7f90a0a082.cf7c2ade.png";